module.exports = __webpack_public_path__ + "img/Ecological Society of America.886c78b2.png";